<template>
  <el-dialog
    title="修改交易"
    :visible="visible"
    width="520px"
    :destroy-on-close="true"
    :lock-scroll="false"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
      <el-form-item label="交易对">
        <el-input :value="pairLabel" disabled />
      </el-form-item>
      <el-form-item label="浮动方向">
        <dict-tag v-if="floatType" dict-code="rate_float_type" :value="floatType" />
        <span v-else>未识别</span>
        <div class="float-tip">{{ floatTip }}</div>
      </el-form-item>
      <el-form-item :label="operateRateLabel" prop="operate_rate">
        <el-input-number
          v-model="form.operate_rate"
          :min="0"
          :precision="6"
          :step="0.01"
          controls-position="right"
          class="ele-fluid ele-text-left" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="updateVisible(false)">取消</el-button>
      <el-button size="small" type="primary" :loading="loading" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TransmodelEdit',
  props: {
    visible: Boolean,
    data: Object
  },
  data() {
    return {
      form: { id: undefined, operate_rate: 0 },
      rules: {
        operate_rate: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false
    };
  },
  computed: {
    pairLabel() {
      return this.data && (this.data.rate_pair_name || this.data.trading_pair);
    },
    floatType() {
      return this.data && this.data.float_type;
    },
    floatTip() {
      if (this.floatType === 'up') return '法币兑换 USDT：运营汇率按上浮处理';
      if (this.floatType === 'down') return 'USDT 兑换法币：运营汇率按下浮处理';
      return '无法识别交易对方向';
    },
    operateRateLabel() {
      if (this.floatType === 'up') return '运营汇率(上浮)';
      if (this.floatType === 'down') return '运营汇率(下浮)';
      return '运营汇率';
    }
  },
  watch: {
    visible(val) {
      if (val) this.initForm();
    },
    data() {
      if (this.visible) this.initForm();
    }
  },
  methods: {
    initForm() {
      this.form = {
        id: this.data && this.data.id ? this.data.id : undefined,
        operate_rate: this.data ? Number(this.data.operate_rate || 0) : 0
      };
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.clearValidate();
      });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return false;
        if (!this.form.id) {
          this.$message.error('缺少记录ID');
          return false;
        }
        this.loading = true;
        this.$http.post('/transmodel/edit', {
          id: this.form.id,
          operate_rate: this.form.operate_rate
        }).then((res) => {
          this.loading = false;
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.updateVisible(false);
            this.$emit('done');
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>

<style scoped>
.float-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
}
</style>
